import { makeStyles } from "tss-react/mui"
import { Box, Divider, Grid, Typography } from "@mui/material"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { ExpandableText } from "../../../../../../shared/components/text/ExpandableText"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ProductionSlipDialogDetails } from "./ProductionSlipDialogDetails"
import { ProductionSlipDialogTable } from "./ProductionSlipDialogTable"
import { ProductionSlip } from "../ordersForCalendarTypes"

type ProductionSlipDialogProps = {
    list: ProductionSlip[]
    open: boolean
    onClose: () => void
}

export const ProductionSlipDialog = ({ list, open, onClose }: ProductionSlipDialogProps) => {
    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="lg"
            dialogTitle={
                <LocalizedStrict id="production-slip-dialog-title">
                    <>Production slip</>
                </LocalizedStrict>
            }
        >
            {list.map((order, index) => (
                <ProductionSlipContent order={order} key={index} />
            ))}
        </StandardDialog>
    )
}

const useStyles = makeStyles()((theme) => ({
    container: {
        gap: "3.75rem",
        padding: "3.75rem",
    },
    title: {
        color: theme.palette.tailwind.slate[700],
        marginBottom: "0.75rem",
    },
    tableBox: {
        display: "flex",
        flexDirection: "column",
        gap: "3.75rem",
    },
    bgBox: {
        padding: "1rem",
        color: theme.palette.tailwind.sky[700],
        background: theme.palette.tailwind.sky[50],
        borderRadius: "0.25rem",
    },
}))

type ProductionSlipContentProps = {
    order: ProductionSlip
}

export const ProductionSlipContent = ({ order }: ProductionSlipContentProps) => {
    const { classes } = useStyles()

    const { orderLines, orderNote } = order

    return (
        <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            wrap="nowrap"
            className={classes.container}
        >
            <Grid item xs={7} className={classes.tableBox}>
                <ProductionSlipDialogTable orderLines={orderLines} />
                <Box>
                    <LocalizedStrict id="production-slip-dialog-note">
                        <Typography variant="h6" className={classes.title}>
                            Order note
                        </Typography>
                    </LocalizedStrict>
                    <Box className={classes.bgBox}>
                        <ExpandableText text={orderNote ?? "-"} variant="body1" />
                    </Box>
                </Box>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <ProductionSlipDialogDetails order={order} />
        </Grid>
    )
}
